import type { LanguageCode } from '@/lib/language';
import type { Notification } from '@/types/notification';

const LANGUAGE_LOCALES: Record<LanguageCode, string> = {
  en: 'en-US',
  zh: 'zh-CN',
  ar: 'ar-SA',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  pt: 'pt-PT',
  nl: 'nl-NL',
  it: 'it-IT',
  pl: 'pl-PL',
  vi: 'vi-VN',
};

function isValidUtcDate(value: string | null | undefined): value is string {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

  const timestamp = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value;
}

export function getNotificationDate(notification: Pick<Notification, 'date' | 'notification_id'>): string | null {
  if (isValidUtcDate(notification.date)) return notification.date;

  const match = notification.notification_id.match(/^NOTIF#(\d{4}-\d{2}-\d{2})#/);
  return isValidUtcDate(match?.[1]) ? match[1] : null;
}

export function formatNotificationDate(
  notification: Pick<Notification, 'created_at' | 'date' | 'notification_id'>,
  language: LanguageCode,
): string {
  const notificationDate = getNotificationDate(notification);
  const date = notificationDate ? new Date(`${notificationDate}T00:00:00Z`) : new Date(notification.created_at);
  if (!Number.isFinite(date.getTime())) return '';

  return new Intl.DateTimeFormat(LANGUAGE_LOCALES[language], {
    month: 'short',
    day: 'numeric',
    ...(notificationDate ? { timeZone: 'UTC' } : {}),
  }).format(date);
}
